import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "land-sub-project-page" }
const _hoisted_2 = { class: "url-bar" }
const _hoisted_3 = { class: "url-item" }
const _hoisted_4 = { class: "url-value" }
const _hoisted_5 = {
  key: 0,
  class: "page-preview"
}
const _hoisted_6 = {
  key: 0,
  class: "hero-placeholder"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "agency-content" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "content-section about-section" }
const _hoisted_15 = { class: "about-content" }
const _hoisted_16 = { class: "paragraphs" }
const _hoisted_17 = {
  key: 0,
  class: "empty-copy"
}
const _hoisted_18 = { class: "content-section features-section" }
const _hoisted_19 = { class: "features-content" }
const _hoisted_20 = {
  key: 0,
  class: "features-grid"
}
const _hoisted_21 = {
  key: 1,
  class: "empty-copy"
}
const _hoisted_22 = { class: "content-section documents-section" }
const _hoisted_23 = { class: "documents-content" }
const _hoisted_24 = { class: "section-heading" }
const _hoisted_25 = {
  key: 0,
  class: "documents-list"
}
const _hoisted_26 = { class: "document-copy" }
const _hoisted_27 = { class: "document-actions" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "empty-copy"
}
const _hoisted_31 = { class: "content-section contact-section" }
const _hoisted_32 = { class: "contact-content" }
const _hoisted_33 = { class: "contact-grid" }
const _hoisted_34 = { class: "contact-person" }
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "contact-photo-placeholder"
}
const _hoisted_37 = { class: "contact-details" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["href"]
const _hoisted_41 = { class: "map-placeholder" }
const _hoisted_42 = { class: "location-copy" }
const _hoisted_43 = { class: "cta-content" }
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_46 = { class: "editor-modal" }
const _hoisted_47 = { class: "modal-header" }
const _hoisted_48 = { class: "modal-body" }
const _hoisted_49 = { class: "field" }
const _hoisted_50 = { class: "field" }
const _hoisted_51 = {
  key: 0,
  class: "uploaded-image-preview"
}
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "file-picker-row" }
const _hoisted_54 = { class: "custom-file-button" }
const _hoisted_55 = { class: "file-selection" }
const _hoisted_56 = { class: "field" }
const _hoisted_57 = {
  key: 0,
  class: "uploaded-image-preview background"
}
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "file-picker-row" }
const _hoisted_60 = { class: "custom-file-button" }
const _hoisted_61 = { class: "file-selection" }
const _hoisted_62 = { class: "field" }
const _hoisted_63 = { class: "color-field" }
const _hoisted_64 = { class: "field" }
const _hoisted_65 = { class: "field" }
const _hoisted_66 = {
  key: 0,
  class: "uploaded-image-preview"
}
const _hoisted_67 = ["src"]
const _hoisted_68 = { class: "file-picker-row" }
const _hoisted_69 = { class: "custom-file-button" }
const _hoisted_70 = { class: "file-selection" }
const _hoisted_71 = { class: "field" }
const _hoisted_72 = { class: "color-field" }
const _hoisted_73 = { class: "field" }
const _hoisted_74 = { class: "field" }
const _hoisted_75 = {
  key: 3,
  class: "field"
}
const _hoisted_76 = { class: "field" }
const _hoisted_77 = { class: "field" }
const _hoisted_78 = { class: "field" }
const _hoisted_79 = { class: "file-picker-row" }
const _hoisted_80 = { class: "custom-file-button" }
const _hoisted_81 = { class: "file-selection" }
const _hoisted_82 = { class: "two-column-fields" }
const _hoisted_83 = { class: "field" }
const _hoisted_84 = { class: "field" }
const _hoisted_85 = { class: "field" }
const _hoisted_86 = { class: "field" }
const _hoisted_87 = { class: "field" }
const _hoisted_88 = {
  key: 0,
  class: "uploaded-image-preview"
}
const _hoisted_89 = ["src"]
const _hoisted_90 = { class: "file-picker-row" }
const _hoisted_91 = { class: "custom-file-button" }
const _hoisted_92 = { class: "file-selection" }
const _hoisted_93 = {
  key: 6,
  class: "field"
}
const _hoisted_94 = { class: "field" }
const _hoisted_95 = { class: "field" }
const _hoisted_96 = { class: "field" }
const _hoisted_97 = { class: "field" }
const _hoisted_98 = { class: "color-field" }
const _hoisted_99 = { class: "modal-footer" }
const _hoisted_100 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["LinkIcon"], { size: 17 }),
      _createElementVNode("div", _hoisted_3, [
        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "url-label" }, "Page URL", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.fullUrl), 1),
        _createElementVNode("button", {
          class: "copy-button",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.copyUrl('full', $setup.fullUrl)))
        }, _toDisplayString($setup.copiedUrl === "full" ? "Copied!" : "Copy"), 1)
      ])
    ]),
    (!$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("section", {
            class: "hero-section",
            style: _normalizeStyle($setup.heroStyle)
          }, [
            _createElementVNode("button", {
              class: "edit-button",
              type: "button",
              "aria-label": "Edit hero",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openModal('hero')))
            }, [
              _createVNode($setup["Pencil"], { size: 18 })
            ]),
            (!$setup.pageData.backgroundImageUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode($setup["ImageIcon"], { size: 48 })
                ]))
              : _createCommentVNode("", true),
            ($setup.content.projectLogoUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "project-logo",
                  src: $setup.content.projectLogoUrl,
                  alt: "Project logo"
                }, null, 8, _hoisted_7))
              : (_openBlock(), _createElementBlock("h1", _hoisted_8, _toDisplayString($setup.content.projectName || $setup.selectedEstate?.title || "Project Name"), 1)),
            (!$setup.pageData.backgroundImageUrl)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Click the edit button to add a hero image"))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              class: "hero-availability-button",
              href: $setup.masterplanUrl,
              style: _normalizeStyle($setup.heroButtonStyle)
            }, [
              _cache[36] || (_cache[36] = _createElementVNode("span", null, "View Land Availability", -1)),
              _createVNode($setup["ArrowRight"], { size: 18 })
            ], 12, _hoisted_10)
          ], 4),
          _createElementVNode("section", {
            class: "agency-bar",
            style: _normalizeStyle($setup.agencyBarStyle)
          }, [
            _createElementVNode("div", _hoisted_11, [
              _cache[37] || (_cache[37] = _createElementVNode("span", { class: "agency-label" }, "Proudly marketed by", -1)),
              ($setup.content.agency?.logoUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "agency-logo",
                    src: $setup.content.agency.logoUrl,
                    alt: "Agency logo"
                  }, null, 8, _hoisted_12))
                : (_openBlock(), _createElementBlock("strong", _hoisted_13, _toDisplayString($setup.content.agency?.name || "Agency Name"), 1))
            ]),
            _createElementVNode("button", {
              class: "edit-button light",
              type: "button",
              "aria-label": "Edit agency branding",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openModal('agency')))
            }, [
              _createVNode($setup["Pencil"], { size: 17 })
            ])
          ], 4),
          _createElementVNode("section", _hoisted_14, [
            _createElementVNode("button", {
              class: "edit-button",
              type: "button",
              "aria-label": "Edit about section",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openModal('about')))
            }, [
              _createVNode($setup["Pencil"], { size: 17 })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h2", null, _toDisplayString($setup.content.aboutHeading || `Welcome to ${$setup.content.projectName || $setup.selectedEstate?.title || "your project"}`), 1),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.aboutParagraphs, (paragraph, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(paragraph), 1))
                }), 128)),
                (!$setup.aboutParagraphs.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Add a description for your project."))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_18, [
            _createElementVNode("button", {
              class: "edit-button",
              type: "button",
              "aria-label": "Edit key features",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openModal('features')))
            }, [
              _createVNode($setup["Pencil"], { size: 17 })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[38] || (_cache[38] = _createElementVNode("h2", null, "Key Features", -1)),
              ($setup.content.features?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.content.features, (feature) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "feature",
                        key: feature
                      }, [
                        _createVNode($setup["Check"], { size: 18 }),
                        _createElementVNode("span", null, _toDisplayString(feature), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_21, "Add the key features buyers should know about."))
            ])
          ]),
          _createElementVNode("section", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[40] || (_cache[40] = _createElementVNode("h2", null, "Documents", -1)),
                _createElementVNode("button", {
                  class: "secondary-button",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openDocumentModal()))
                }, [
                  _createVNode($setup["Plus"], { size: 17 }),
                  _cache[39] || (_cache[39] = _createElementVNode("span", null, "Add", -1))
                ])
              ]),
              ($setup.content.documents?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.content.documents, (document) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "document-row",
                        key: document.id
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("strong", null, _toDisplayString(document.name), 1),
                          _createElementVNode("span", null, _toDisplayString(document.description || document.fileName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("button", {
                            class: "icon-button",
                            type: "button",
                            "aria-label": "Edit document",
                            onClick: ($event: any) => ($setup.openDocumentModal(document))
                          }, [
                            _createVNode($setup["Pencil"], { size: 17 })
                          ], 8, _hoisted_28),
                          _createElementVNode("button", {
                            class: "icon-button danger",
                            type: "button",
                            "aria-label": "Delete document",
                            onClick: ($event: any) => ($setup.deleteDocument(document.id))
                          }, [
                            _createVNode($setup["Trash2"], { size: 17 })
                          ], 8, _hoisted_29)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_30, "No project-page documents have been added."))
            ])
          ]),
          _createElementVNode("section", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[43] || (_cache[43] = _createElementVNode("h2", null, "Contact", -1)),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", {
                  class: "contact-card",
                  style: _normalizeStyle($setup.contactCardStyle)
                }, [
                  _createElementVNode("button", {
                    class: "edit-button",
                    type: "button",
                    "aria-label": "Edit contact",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openModal('contact')))
                  }, [
                    _createVNode($setup["Pencil"], { size: 17 })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    ($setup.content.contact?.photoUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "contact-photo",
                          src: $setup.content.contact.photoUrl,
                          alt: "Contact"
                        }, null, 8, _hoisted_35))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createVNode($setup["UserRound"], { size: 28 })
                        ])),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString($setup.content.contact?.name || "Contact name"), 1),
                      _createElementVNode("span", null, _toDisplayString($setup.content.contact?.title || "Sales Consultant"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    ($setup.content.contact?.phone)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                          _createVNode($setup["Phone"], { size: 16 }),
                          _createTextVNode(_toDisplayString($setup.content.contact.phone), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.content.contact?.email)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                          _createVNode($setup["Mail"], { size: 16 }),
                          _createTextVNode(_toDisplayString($setup.content.contact.email), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 4),
                _createElementVNode("a", {
                  class: "location-card",
                  href: $setup.googleMapsUrl,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createElementVNode("button", {
                    class: "edit-button",
                    type: "button",
                    "aria-label": "Edit location",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.openModal('location')), ["prevent"]))
                  }, [
                    _createVNode($setup["Pencil"], { size: 17 })
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode($setup["MapPin"], { size: 18 }),
                    _cache[41] || (_cache[41] = _createElementVNode("span", null, "Open in Google Maps", -1))
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode($setup["MapPin"], { size: 17 }),
                    _createElementVNode("div", null, [
                      _cache[42] || (_cache[42] = _createElementVNode("strong", null, "Location", -1)),
                      _createElementVNode("span", null, _toDisplayString($setup.content.locationAddress || "Add a project-page address"), 1)
                    ])
                  ])
                ], 8, _hoisted_40)
              ])
            ])
          ]),
          _createElementVNode("section", {
            class: "call-to-action",
            style: _normalizeStyle($setup.ctaStyle)
          }, [
            _createElementVNode("button", {
              class: "edit-button light",
              type: "button",
              "aria-label": "Edit call to action",
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openModal('cta')))
            }, [
              _createVNode($setup["Pencil"], { size: 17 })
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("h2", null, _toDisplayString($setup.content.callToAction?.heading || "Ready to Explore?"), 1),
              _createElementVNode("p", null, _toDisplayString($setup.content.callToAction?.subtext || "Get in touch with our sales team to learn more about available lots and pricing."), 1),
              _createElementVNode("a", {
                class: "cta-button",
                href: $setup.masterplanUrl
              }, _toDisplayString($setup.content.callToAction?.buttonText || "View Land Availability"), 9, _hoisted_44)
            ])
          ], 4)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_45, "Loading project page…")),
    ($setup.activeModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal-backdrop",
          onClick: _withModifiers($setup.closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("h3", null, _toDisplayString($setup.modalTitle), 1),
              _createElementVNode("button", {
                class: "icon-button",
                type: "button",
                "aria-label": "Close",
                onClick: $setup.closeModal
              }, [
                _createVNode($setup["X"], { size: 20 })
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              ($setup.activeModal === 'hero')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("label", _hoisted_49, [
                      _cache[44] || (_cache[44] = _createElementVNode("span", null, [
                        _createTextVNode("Project Name "),
                        _createElementVNode("small", null, "(shown when no logo is provided)")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.heroForm.projectName) = $event)),
                        type: "text"
                      }, null, 512), [
                        [
                          _vModelText,
                          $setup.heroForm.projectName,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _cache[46] || (_cache[46] = _createElementVNode("span", null, [
                        _createTextVNode("Project Logo "),
                        _createElementVNode("small", null, "(optional)")
                      ], -1)),
                      ($setup.projectLogoPreviewUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createElementVNode("img", {
                              src: $setup.projectLogoPreviewUrl,
                              alt: "Project logo preview"
                            }, null, 8, _hoisted_52)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, [
                          _createVNode($setup["Upload"], { size: 16 }),
                          _cache[45] || (_cache[45] = _createElementVNode("span", null, "Choose Logo", -1)),
                          _createElementVNode("input", {
                            class: "file-input-hidden",
                            type: "file",
                            accept: "image/png,image/jpeg,image/svg+xml,image/webp",
                            onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.setFile('projectLogo', $event)))
                          }, null, 32)
                        ]),
                        _createElementVNode("span", _hoisted_55, _toDisplayString($setup.projectLogoDisplayName || "No logo selected"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _cache[48] || (_cache[48] = _createElementVNode("span", null, "Background Image", -1)),
                      ($setup.backgroundPreviewUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("img", {
                              src: $setup.backgroundPreviewUrl,
                              alt: "Background image preview"
                            }, null, 8, _hoisted_58)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("label", _hoisted_60, [
                          _createVNode($setup["Upload"], { size: 16 }),
                          _cache[47] || (_cache[47] = _createElementVNode("span", null, "Choose Image", -1)),
                          _createElementVNode("input", {
                            class: "file-input-hidden",
                            type: "file",
                            accept: "image/png,image/jpeg,image/webp",
                            onChange: _cache[11] || (_cache[11] = ($event: any) => ($setup.setFile('hero', $event)))
                          }, null, 32)
                        ]),
                        _createElementVNode("span", _hoisted_61, _toDisplayString($setup.backgroundDisplayName || "No image selected"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _cache[49] || (_cache[49] = _createElementVNode("span", null, "Button Colour", -1)),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("label", {
                          class: "input-color",
                          style: _normalizeStyle({ backgroundColor: $setup.heroForm.buttonColor }),
                          "aria-label": "Choose button colour"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "color",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.heroForm.buttonColor) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.heroForm.buttonColor]
                          ])
                        ], 4),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.heroForm.buttonColor) = $event)),
                          type: "text",
                          placeholder: "#334e68"
                        }, null, 512), [
                          [_vModelText, $setup.heroForm.buttonColor]
                        ])
                      ])
                    ])
                  ], 64))
                : ($setup.activeModal === 'agency')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("label", _hoisted_64, [
                        _cache[50] || (_cache[50] = _createElementVNode("span", null, [
                          _createTextVNode("Agency Name "),
                          _createElementVNode("small", null, "(shown when no logo is provided)")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.agencyForm.name) = $event)),
                          type: "text"
                        }, null, 512), [
                          [
                            _vModelText,
                            $setup.agencyForm.name,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _cache[52] || (_cache[52] = _createElementVNode("span", null, [
                          _createTextVNode("Agency Logo "),
                          _createElementVNode("small", null, "(optional)")
                        ], -1)),
                        ($setup.agencyLogoPreviewUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _createElementVNode("img", {
                                src: $setup.agencyLogoPreviewUrl,
                                alt: "Agency logo preview"
                              }, null, 8, _hoisted_67)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("label", _hoisted_69, [
                            _createVNode($setup["Upload"], { size: 16 }),
                            _cache[51] || (_cache[51] = _createElementVNode("span", null, "Choose Logo", -1)),
                            _createElementVNode("input", {
                              class: "file-input-hidden",
                              type: "file",
                              accept: "image/png,image/jpeg,image/svg+xml,image/webp",
                              onChange: _cache[15] || (_cache[15] = ($event: any) => ($setup.setFile('agencyLogo', $event)))
                            }, null, 32)
                          ]),
                          _createElementVNode("span", _hoisted_70, _toDisplayString($setup.agencyLogoDisplayName || "No logo selected"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _cache[53] || (_cache[53] = _createElementVNode("span", null, [
                          _createTextVNode("Brand Colour "),
                          _createElementVNode("small", null, "(optional)")
                        ], -1)),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("label", {
                            class: "input-color",
                            style: _normalizeStyle({ backgroundColor: $setup.agencyForm.brandColor }),
                            "aria-label": "Choose brand colour"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "color",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.agencyForm.brandColor) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.agencyForm.brandColor]
                            ])
                          ], 4),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.agencyForm.brandColor) = $event)),
                            type: "text",
                            placeholder: "#1e3a5f"
                          }, null, 512), [
                            [_vModelText, $setup.agencyForm.brandColor]
                          ])
                        ])
                      ])
                    ], 64))
                  : ($setup.activeModal === 'about')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("label", _hoisted_73, [
                          _cache[54] || (_cache[54] = _createElementVNode("span", null, "Heading", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.aboutForm.heading) = $event)),
                            type: "text"
                          }, null, 512), [
                            [
                              _vModelText,
                              $setup.aboutForm.heading,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_74, [
                          _cache[55] || (_cache[55] = _createElementVNode("span", null, "Description", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.aboutForm.description) = $event)),
                            rows: "7"
                          }, null, 512), [
                            [_vModelText, $setup.aboutForm.description]
                          ]),
                          _cache[56] || (_cache[56] = _createElementVNode("small", null, "Use blank lines to separate paragraphs", -1))
                        ])
                      ], 64))
                    : ($setup.activeModal === 'features')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_75, [
                          _cache[57] || (_cache[57] = _createElementVNode("span", null, "Features", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.featuresText) = $event)),
                            rows: "8"
                          }, null, 512), [
                            [_vModelText, $setup.featuresText]
                          ]),
                          _cache[58] || (_cache[58] = _createElementVNode("small", null, "One feature per line — each line becomes a bullet point", -1))
                        ]))
                      : ($setup.activeModal === 'document')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createElementVNode("label", _hoisted_76, [
                              _cache[59] || (_cache[59] = _createElementVNode("span", null, "Name", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.documentForm.name) = $event)),
                                type: "text",
                                placeholder: "e.g. Master Plan"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  $setup.documentForm.name,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("label", _hoisted_77, [
                              _cache[60] || (_cache[60] = _createElementVNode("span", null, [
                                _createTextVNode("Description "),
                                _createElementVNode("small", null, "(optional)")
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.documentForm.description) = $event)),
                                type: "text",
                                placeholder: "Brief description"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  $setup.documentForm.description,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _cache[62] || (_cache[62] = _createElementVNode("span", null, "File", -1)),
                              _createElementVNode("div", _hoisted_79, [
                                _createElementVNode("label", _hoisted_80, [
                                  _createVNode($setup["Upload"], { size: 16 }),
                                  _cache[61] || (_cache[61] = _createElementVNode("span", null, "Choose File", -1)),
                                  _createElementVNode("input", {
                                    class: "file-input-hidden",
                                    type: "file",
                                    accept: "application/pdf",
                                    onChange: _cache[23] || (_cache[23] = ($event: any) => ($setup.setFile('document', $event)))
                                  }, null, 32)
                                ]),
                                _createElementVNode("span", _hoisted_81, _toDisplayString($setup.documentFile?.name || $setup.documentForm.fileName || "No file selected"), 1)
                              ])
                            ])
                          ], 64))
                        : ($setup.activeModal === 'contact')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("label", _hoisted_83, [
                                  _cache[63] || (_cache[63] = _createElementVNode("span", null, "Name", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.contactForm.name) = $event)),
                                    type: "text"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      $setup.contactForm.name,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", _hoisted_84, [
                                  _cache[64] || (_cache[64] = _createElementVNode("span", null, "Title", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.contactForm.title) = $event)),
                                    type: "text"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      $setup.contactForm.title,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", _hoisted_85, [
                                  _cache[65] || (_cache[65] = _createElementVNode("span", null, "Phone", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.contactForm.phone) = $event)),
                                    type: "tel"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      $setup.contactForm.phone,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", _hoisted_86, [
                                  _cache[66] || (_cache[66] = _createElementVNode("span", null, "Email", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.contactForm.email) = $event)),
                                    type: "email"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      $setup.contactForm.email,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_87, [
                                _cache[68] || (_cache[68] = _createElementVNode("span", null, "Agent Photo", -1)),
                                ($setup.contactPhotoPreviewUrl)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                      _createElementVNode("img", {
                                        src: $setup.contactPhotoPreviewUrl,
                                        alt: "Agent photo preview"
                                      }, null, 8, _hoisted_89)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("label", _hoisted_91, [
                                    _createVNode($setup["Upload"], { size: 16 }),
                                    _cache[67] || (_cache[67] = _createElementVNode("span", null, "Choose Photo", -1)),
                                    _createElementVNode("input", {
                                      class: "file-input-hidden",
                                      type: "file",
                                      accept: "image/png,image/jpeg,image/webp",
                                      onChange: _cache[28] || (_cache[28] = ($event: any) => ($setup.setFile('contactPhoto', $event)))
                                    }, null, 32)
                                  ]),
                                  _createElementVNode("span", _hoisted_92, _toDisplayString($setup.contactPhotoDisplayName || "No photo selected"), 1)
                                ])
                              ])
                            ], 64))
                          : ($setup.activeModal === 'location')
                            ? (_openBlock(), _createElementBlock("label", _hoisted_93, [
                                _cache[69] || (_cache[69] = _createElementVNode("span", null, "Address", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.locationAddress) = $event)),
                                  type: "text"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    $setup.locationAddress,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _cache[70] || (_cache[70] = _createElementVNode("small", null, "This is displayed on the location card and opens in Google Maps", -1))
                              ]))
                            : ($setup.activeModal === 'cta')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                  _createElementVNode("label", _hoisted_94, [
                                    _cache[71] || (_cache[71] = _createElementVNode("span", null, "Heading", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.ctaForm.heading) = $event)),
                                      type: "text"
                                    }, null, 512), [
                                      [
                                        _vModelText,
                                        $setup.ctaForm.heading,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ]),
                                  _createElementVNode("label", _hoisted_95, [
                                    _cache[72] || (_cache[72] = _createElementVNode("span", null, "Sub-text", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.ctaForm.subtext) = $event)),
                                      rows: "3"
                                    }, null, 512), [
                                      [_vModelText, $setup.ctaForm.subtext]
                                    ])
                                  ]),
                                  _createElementVNode("label", _hoisted_96, [
                                    _cache[73] || (_cache[73] = _createElementVNode("span", null, "Button Text", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.ctaForm.buttonText) = $event)),
                                      type: "text"
                                    }, null, 512), [
                                      [
                                        _vModelText,
                                        $setup.ctaForm.buttonText,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_97, [
                                    _cache[74] || (_cache[74] = _createElementVNode("span", null, [
                                      _createTextVNode("Footer Colour "),
                                      _createElementVNode("small", null, "(optional)")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_98, [
                                      _createElementVNode("label", {
                                        class: "input-color",
                                        style: _normalizeStyle({ backgroundColor: $setup.ctaForm.footerColor }),
                                        "aria-label": "Choose footer colour"
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "color",
                                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.ctaForm.footerColor) = $event))
                                        }, null, 512), [
                                          [_vModelText, $setup.ctaForm.footerColor]
                                        ])
                                      ], 4),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.ctaForm.footerColor) = $event)),
                                        type: "text",
                                        placeholder: "#1e293b"
                                      }, null, 512), [
                                        [_vModelText, $setup.ctaForm.footerColor]
                                      ])
                                    ])
                                  ])
                                ], 64))
                              : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("button", {
                class: "secondary-button",
                type: "button",
                onClick: $setup.closeModal
              }, "Cancel"),
              _createElementVNode("button", {
                class: "primary-button",
                type: "button",
                disabled: $setup.saving,
                onClick: $setup.saveActiveModal
              }, _toDisplayString($setup.saving ? "Saving…" : "Save"), 9, _hoisted_100)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}